// Tracks whether the visitor has chosen to enter the app (browse salons) during
// this browsing session. Stored in sessionStorage (not localStorage) so that
// every fresh visit to the site defaults to the marketing welcome/landing page.
export const BROWSE_INTENT_KEY = 'adwary_browsing';
export const PROMO_DISMISSED_KEY = 'adwary_biz_promo_dismissed';

export function isBrowsing() {
  try {
    return sessionStorage.getItem(BROWSE_INTENT_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markBrowsing() {
  try {
    sessionStorage.setItem(BROWSE_INTENT_KEY, 'true');
  } catch { /* ignore storage errors */ }
}

export function isPromoDismissed() {
  try {
    return sessionStorage.getItem(PROMO_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function dismissPromo() {
  try {
    sessionStorage.setItem(PROMO_DISMISSED_KEY, 'true');
  } catch { /* ignore storage errors */ }
}
